var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2414_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 44.0001C34.6503 44.0001 44.5001 34.1503 44.5001 22C44.5001 9.84976 34.6503 0 22.5 0C10.3498 0 0.5 9.84976 0.5 22C0.5 34.1503 10.3498 44.0001 22.5 44.0001Z",
    fill: "#E24C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5001 21.9999C44.5001 34.1 34.6001 44 22.5 44C15.4876 44 9.30005 40.8375 5.3125 35.75C9.025 38.775 13.8375 40.5625 19.0625 40.5625C31.1625 40.5625 41.0625 30.6625 41.0625 18.5625C41.0625 13.3375 39.275 8.525 36.25 4.8125C41.3376 8.79986 44.5001 14.9874 44.5001 21.9999Z",
    fill: "#D1403F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5374 32.0374C31.7125 32.8624 30.3374 32.8624 29.5124 32.0374L22.5 25.025L15.4875 32.0374C14.6625 32.8624 13.2874 32.8624 12.4625 32.0374C11.6375 31.2125 11.6375 29.8374 12.4625 29.0124L19.4749 22L12.4625 14.9875C11.6375 14.1625 11.6375 12.7874 12.4625 11.9625C13.2874 11.1375 14.6625 11.1375 15.4875 11.9625L22.5 18.9749L29.5124 11.9625C30.3374 11.1375 31.7125 11.1375 32.5374 11.9625C33.3624 12.7874 33.3624 14.1625 32.5374 14.9875L25.525 22L32.5374 29.0124C33.3624 29.8374 33.3624 31.2124 32.5374 32.0374Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2414_2450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.34247f663ecde693bccdc96213bea183.svg";
export { ForwardRef as ReactComponent };